import { getGridBooleanOperators } from '@mui/x-data-grid-pro';

export const getBooleanOperators = () => {
	return getGridBooleanOperators().filter(operator => operator.value);
};
